"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var FreeSampleButton_1 = __importDefault(require("./FreeSampleButton"));
var BuyNowButton_1 = __importDefault(require("./BuyNowButton"));
var BuyForm_1 = __importDefault(require("./BuyForm"));
var react_1 = require("react");
var material_1 = require("@mui/material");
// utils
var determineEnv_1 = __importDefault(require("../utils/determineEnv"));
// data
var config_json_1 = __importDefault(require("../config.json"));
var CustomFontTheme = (0, material_1.createTheme)({
    typography: {
        allVariants: {
            fontSize: 16,
        },
    },
});
var isValidToday = function (validOn) {
    var today = new Date().toLocaleString('en-us', { weekday: 'long' }).toLocaleLowerCase();
    return validOn.includes(today);
};
var timeFromDifference = function (validFromTime) {
    var now = new Date();
    var validFromDateTime = new Date();
    var validFromTimeArray = validFromTime.split(':');
    validFromDateTime.setHours(validFromTimeArray[0]);
    validFromDateTime.setMinutes(validFromTimeArray[1]);
    validFromDateTime.setSeconds(0);
    var difference = now.getTime() - validFromDateTime.getTime();
    return difference;
};
var timeUntilDifference = function (validUntilTime) {
    var now = new Date();
    var validUntilDateTime = new Date();
    var validUntilTimeArray = validUntilTime.split(':');
    validUntilDateTime.setHours(validUntilTimeArray[0]);
    validUntilDateTime.setMinutes(validUntilTimeArray[1]);
    validUntilDateTime.setSeconds(59);
    var difference = validUntilDateTime.getTime() - now.getTime();
    return difference;
};
var Checkout = function (_a) {
    var courseId = _a.courseId, courseName = _a.courseName, price = _a.price, priceOriginal = _a.priceOriginal, freeSample = _a.freeSample;
    var _b = __read((0, react_1.useState)(false), 2), buyFormEnabled = _b[0], setBuyFormEnabled = _b[1];
    var _c = __read((0, react_1.useState)(price), 2), finalPrice = _c[0], setFinalPrice = _c[1];
    // get discount
    (0, react_1.useEffect)(function () {
        var env = (0, determineEnv_1.default)();
        var opositandoApi = config_json_1.default.opositandoApi[env];
        fetch("".concat(opositandoApi, "/getDiscount"), {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(function (res) { return res.json(); })
            .then(function (data) {
            var active = data.active, price = data.price, validFromTime = data.validFromTime, validUntilTime = data.validUntilTime, validOn = data.validOn;
            if (active &&
                price &&
                isValidToday(validOn) &&
                timeFromDifference(validFromTime) > 0 &&
                timeUntilDifference(validUntilTime) > 0) {
                setFinalPrice(price);
            }
        });
    }, []);
    return ((0, jsx_runtime_1.jsxs)(material_1.ThemeProvider, __assign({ theme: CustomFontTheme }, { children: [!buyFormEnabled && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [freeSample && ((0, jsx_runtime_1.jsx)(FreeSampleButton_1.default, { freeSampleUrl: freeSample })), (0, jsx_runtime_1.jsx)(BuyNowButton_1.default, { price: finalPrice, setBuyFormEnabled: setBuyFormEnabled }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "opo-checkout-payment-logos" }, { children: [(0, jsx_runtime_1.jsx)("object", { type: "image/svg+xml", data: "/static/apple-pay.svg" }), (0, jsx_runtime_1.jsx)("object", { type: "image/svg+xml", data: "/static/google-pay.svg" }), (0, jsx_runtime_1.jsx)("object", { type: "image/svg+xml", data: "/static/visa.svg" }), (0, jsx_runtime_1.jsx)("object", { type: "image/svg+xml", data: "/static/mastercard.svg" }), (0, jsx_runtime_1.jsx)("object", { type: "image/svg+xml", data: "/static/amex.svg" })] }))] })), buyFormEnabled && ((0, jsx_runtime_1.jsx)(BuyForm_1.default, { price: finalPrice, courseId: courseId, courseName: courseName, setBuyFormEnabled: setBuyFormEnabled }))] })));
};
exports.default = Checkout;
//# sourceMappingURL=index.js.map